import {
  alpha,
  Box,
  Button,
  darken,
  Dialog,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import {
  DeleteConfirmationMode,
  useDeleteConfirmation,
} from "./DeleteConfirmationModalContext";
import { ComponentDialogTransition } from "../../ComponentDialog";
import { Trash, TriangleAlert, X } from "lucide-react";

const DeleteConfirmationModal = () => {
  const { isOpen, deleteMode, closeDialog, confirmDelete } =
    useDeleteConfirmation();
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Dialog
        open={isOpen}
        TransitionComponent={ComponentDialogTransition}
        onClose={closeDialog}
        PaperProps={{
          sx: {
            width: { xs: "80vw", sm: "60vw", md: "40vw", lg: "40vw" },
            height: "60vh",
            maxHeight: 580,
            maxWidth: 580,
            margin: "unset",
            p: 4,
          },
        }}
      >
        <IconButton
          onClick={closeDialog}
          sx={{
            position: "absolute",
            top: theme.spacing(2),
            right: theme.spacing(2),
          }}
        >
          <X />
        </IconButton>

        <Box display={"flex"} flexDirection={"column"} gap={3}>
          <Typography variant="h4">Confirm delete item</Typography>
          <Typography variant="body1">
            This action will also drop all client data related with
            {deleteMode === DeleteConfirmationMode.WEEK
              ? " components from this week"
              : " this component"}
          </Typography>
        </Box>

        <TriangleAlert
          size={175}
          color={theme.palette.error.light}
          strokeWidth={1}
          style={{
            padding: theme.spacing(4),
            margin: "auto",
            width: "fit-content",
            height: "fit-content",
          }}
        />

        <Box display={"flex"} gap={2} justifyContent={"right"}>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            sx={{
              height: "fit-content",
              color: theme.palette.common.black,
              borderColor: theme.palette.common.black,
              ":hover": {
                background: darken(theme.palette.common.white, 0.05),
              },
            }}
            onClick={closeDialog}
          >
            Discard
          </Button>

          <Button
            fullWidth
            variant="contained"
            size="large"
            sx={{
              background: theme.palette.error.light,
              color: theme.palette.error.contrastText,
              ":hover": {
                background: alpha(theme.palette.error.light, 0.8),
              },
            }}
            endIcon={<Trash />}
            onClick={confirmDelete}
          >
            {isSm ? "Yes" : "Yes , delete it"}
          </Button>
        </Box>
      </Dialog>
    </>
  );
};

export default DeleteConfirmationModal;
